import RavelloService from '@/services/ravello'

export const Assets = {
	name: 'Assets',
	route: 'website-assets',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} assets` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Asset = {
	name: 'New asset',
	route: 'website-asset',
	params: ['website', 'asset'],
	lazyName: {
		fn: async (website, asset) => (asset === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/assets/${asset}`)
		),
		params: ['website', 'asset'],
		field: 'filename',
	},
}

export const Complexes = {
	name: 'Strings',
	route: 'website-complexes',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} complexes` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const ComplexesActivate = {
	name: 'Activate complexes',
	route: 'website-complexes-activate',
}

export const Complex = {
	name: ' meta',
	route: 'website-complex',
	params: ['website', 'complex'],
	lazyName: {
		fn: async (website, complex) => {
			const entry = await RavelloService
				.get(`/v2/websites/${website}/complexes/${complex}/complex?fields=name`)
			return { name: `${entry.name}` }
		},
		params: ['website', 'complex'],
		field: 'name',
	},
}

export const Images = {
	name: 'Images',
	route: 'website-images',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} images` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Image = {
	name: 'New image',
	route: 'website-image',
	params: ['website', 'image'],
	lazyName: {
		fn: async (website, image) => (image === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/images/${image}`)
		),
		params: ['website', 'image'],
		field: 'filename',
	},
}

export const Namespaces = {
	name: 'Namespaces',
	route: 'website-namespaces',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} namespaces` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Namespace = {
	name: 'New namespace',
	route: 'website-namespace',
	params: ['website', 'namespace'],
	lazyName: {
		fn: async (website, namespace) => (namespace === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/namespaces/${namespace}?fields=name`)
		),
		params: ['website', 'namespace'],
		field: 'name',
	},
}

export const NavItems = {
	name: 'Navigation',
	route: 'website-navitems',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} navigation` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const NavItem = {
	name: 'New navigation item',
	route: 'website-navitem',
	params: ['website', 'item'],
	lazyName: {
		fn: async (website, item) => (item === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/navitems/${item}?fields=name`)
		),
		params: ['website', 'item'],
		field: 'name',
	},
}

export const Pages = {
	name: 'Pages',
	route: 'website-pages',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} pages` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Page = {
	name: 'New page',
	route: 'website-page',
	params: ['website', 'page'],
	lazyName: {
		fn: async (website, page) => (page === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/pages/${page}`)
		),
		params: ['website', 'page'],
		field: 'name',
	},
}

export const Redirections = {
	name: 'Redirections',
	route: 'website-redirections',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} redirections` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Redirection = {
	name: 'New redirection',
	route: 'website-redirection',
	params: ['website', 'redirection'],
	lazyName: {
		fn: async (website, redirection) => (redirection === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/redirections/${redirection}`)
		),
		params: ['website', 'redirection'],
		field: 'from',
	},
}

export const Strings = {
	name: 'Strings',
	route: 'website-strings',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} strings` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const String = {
	name: 'New string',
	route: 'website-string',
	params: ['website', 'string'],
	lazyName: {
		fn: async (website, str) => (str === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/strings/${str}?fields=slug`)
		),
		params: ['website', 'string'],
		field: 'slug',
	},
}

export const StringCategories = {
	name: 'String categories',
	route: 'string-categories',
}

export const StringCategory = {
	name: 'New category',
	route: 'string-category',
	params: ['category'],
	lazyName: {
		fn: async category => (category === 'new'
			? null
			: RavelloService.get(`/v2/stringcategories/${category}`)
		),
		params: ['category'],
		field: 'name',
	},
}

export const Tags = {
	name: 'Pages',
	route: 'website-tags',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} tags` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const Tag = {
	name: 'New tag',
	route: 'website-tag',
	params: ['website', 'tag'],
	lazyName: {
		fn: async (website, tag) => (tag === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}/tags/${tag}`)
		),
		params: ['website', 'tag'],
		field: 'name',
	},
}

export const Units = {
	name: 'Strings',
	route: 'website-units',
	params: ['website'],
	lazyName: {
		fn: async (website) => {
			const entry = await RavelloService.get(`/v2/websites/${website}?fields=name`)
			return { name: `${entry.name} units` }
		},
		params: ['website'],
		field: 'name',
	},
}

export const UnitsActivate = {
	name: 'Activate units',
	route: 'website-units-activate',
}

export const Unit = {
	name: ' meta',
	route: 'website-unit',
	params: ['website', 'unit'],
	lazyName: {
		fn: async (website, unit) => {
			const entry = await RavelloService.get(`/v2/websites/${website}/units/${unit}/unit?fields=name,code`)
			return { name: `${entry.name} (${entry.code})` }
		},
		params: ['website', 'unit'],
		field: 'name',
	},
}

export const Websites = {
	name: 'Websites',
	route: 'websites',
}

export const Website = {
	name: 'New website',
	route: 'website',
	params: ['website'],
	lazyName: {
		fn: async website => (website === 'new'
			? null
			: RavelloService.get(`/v2/websites/${website}`)
		),
		params: ['website'],
		field: 'name',
	},
}


/* TEMPLATES */
export const Template = {
	name: 'New template',
	route: 'website-template',
	params: ['template'],
	lazyName: {
		fn: async template => (template === 'new'
			? null
			: RavelloService.get(`/v2/websitetemplates/${template}`)
		),
		params: ['template'],
		field: 'name',
	},
}

export const Templates = {
	name: 'Templates',
	route: 'website-templates',
}

export const TemplateNamespaces = {
	name: 'Namespaces',
	route: 'website-template-namespaces',
	params: ['template'],
	lazyName: {
		fn: async (template) => {
			const entry = await RavelloService.get(`/v2/websitetemplates/${template}?fields=name`)
			return { name: `${entry.name} namespaces` }
		},
		params: ['template'],
		field: 'name',
	},
}

export const TemplateNamespace = {
	name: 'New namespace',
	route: 'website-template-namespace',
	params: ['template', 'namespace'],
	lazyName: {
		fn: async (template, namespace) => (namespace === 'new'
			? null
			: RavelloService.get(`/v2/websitetemplates/${template}/namespaces/${namespace}?fields=name`)
		),
		params: ['template', 'namespace'],
		field: 'name',
	},
}

export const TemplatePages = {
	name: 'Fixed Pages',
	route: 'website-template-pages',
	params: ['template'],
	lazyName: {
		fn: async (template) => {
			const entry = await RavelloService.get(`/v2/websitetemplates/${template}?fields=name`)
			return { name: `${entry.name} fixed pages` }
		},
		params: ['template'],
		field: 'name',
	},
}

export const TemplatePage = {
	name: 'New page',
	route: 'website-template-page',
	params: ['template', 'page'],
	lazyName: {
		fn: async (template, page) => (page === 'new'
			? null
			: RavelloService.get(`/v2/websitetemplates/${template}/pages/${page}?fields=name`)
		),
		params: ['template', 'page'],
		field: 'name',
	},
}

export const PageTemplates = {
	name: 'Page Templates',
	route: 'website-template-pagetemplates',
	params: ['template'],
	lazyName: {
		fn: async (template) => {
			const entry = await RavelloService.get(`/v2/websitetemplates/${template}?fields=name`)
			return { name: `${entry.name} page templates` }
		},
		params: ['template'],
		field: 'name',
	},
}

export const TemplateStrings = {
	name: 'Strings',
	route: 'website-template-strings',
	params: ['template'],
	lazyName: {
		fn: async (template) => {
			const entry = await RavelloService.get(`/v2/websitetemplates/${template}?fields=name`)
			return { name: `${entry.name} strings` }
		},
		params: ['template'],
		field: 'name',
	},
}

export const TemplateString = {
	name: 'New string',
	route: 'website-template-string',
	params: ['template', 'string'],
	lazyName: {
		fn: async (template, str) => (str === 'new'
			? null
			: RavelloService.get(`/v2/websitetemplates/${template}/strings/${str}?fields=slug`)
		),
		params: ['template', 'string'],
		field: 'slug',
	},
}
